<template>
  <v-app dark>
    <div id="app">
      <component :is="layout">
        <transition name="fade" mode="out-in">
          <router-view/>
        </transition>
      </component>
    </div>
  </v-app>
</template>

<script>
import AuthLayout from './components/layouts/Auth'
import DefaultLayout from './components/layouts/Default'
export default {
  name: 'App',
  components: {
    'auth-layout': AuthLayout,
    'default-layout': DefaultLayout
  },
  data () {
    return {
      defaultLayout: 'auth'
    }
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || this.defaultLayout) + '-layout'
    }
  },
  created () {
    this.$store.commit('authModule/SET_CHECK')
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue